// import IMInit from '@/untils/im'
const passport = {
  methods: {
    userRedirect(userInfo, redrictPath = '', type = 'normal') {
      console.log("userid")
  
      if(!userInfo.wechat_subscribe) {
        // 用户未关注公众号
        this.$router.replace('/subscribe');
      }else {
        if(type == 'scan' || type == 'invited') {
          console.log(type);
          return true;
        }else {
          if(!userInfo.user_id) {

            console.log(userInfo)
            // 用户未选择角色
            this.$router.replace('/choose-role');
          }else {
            switch(parseInt(userInfo.role)) {
              // 如果是医生
              case 1: {
                switch(userInfo.doc_status) {
                  case 1: {
                    // 未填写完认证信息
                    this.$router.replace('/doctor/baseinfo');
                  };break;
                  case 2: {
                    // 审核中
                    this.$router.replace('/doctor/waitting');
                  };break;
                  case 3: {
                    // 审核不通过
                    this.$router.replace('/doctor/waitting');
                  };break;
                  case 4: {
                    // 正常
                    // 初始化融云
                    if(redrictPath && redrictPath == '/doctor/chat-room') {
                      let _this = this;
                      this.$root.IMInit(userInfo.token, {
                        connectSuccess() {
                          console.log('connect');
                          _this.$router.replace('/doctor/consulting-room');
                        }
                      });
                    }else {
                      this.$root.IMInit(userInfo.token, {});
                      // 如果返回的医事服务费为0，则判断医生为首次进入个人中心，需先设置医事服务费
                      if(parseFloat(userInfo.doc_money) == 0) {
                        this.$router.replace('/doctor/first-config');
                      }else {
                        // 如果有来源url则跳转至来源，否则跳转至医生首页
                        if(redrictPath && redrictPath != '/') {
                          this.$router.replace(redrictPath);
                        }else {
                          this.$router.replace('/doctor');
                        }
                      }
                    }
                  };break;
                }
              };break;
              // 如果是患者
              case 2: {
                // this.$router.replace({path: '/patient/binding', query: {doc_id: 1, scan: true}});
                // this.$router.replace('/patient/medical-record?doc_id=1&private_id=18');
                // this.$router.replace('/patient/mine');
                // 初始化融云
                // IMInit(userInfo.token, {});
                // 如果患者没有绑定医生，则去绑定页
                if(userInfo.hasDoctor == 0) {
                  this.$router.replace('/patient/code-binding');
                }else {
                  let _this = this;
                  this.$root.IMInit(userInfo.token, {
                    connectSuccess() {
                      // IM链接成功后再进行页面跳转
                      if(redrictPath && redrictPath != '/') {
                        _this.$router.replace(redrictPath)
                      }else {
                        _this.$router.replace('/patient');
                      }
                    }
                  })
                }
              };break;
            }
          }
        }

      }
    }
  }
}
export default passport;



// WEBPACK FOOTER //
// ./src/untils/passport.js